(function () {
	'use strict';
	var $infoBox = $('.js-question');

	$infoBox.on('click', function() {
		var $self = $(this),
			$target = $self,
			targetOpened = !!$target.hasClass('expand');

		// Close all boxes
		$infoBox.removeClass('expand');

		// Check current box for toggle
		if (targetOpened) {
			$target.removeClass('expand');
		} else {
			$target.addClass('expand');
		}
	});

})();

var sliderInfNotiSecMedRating = tns({
	"container": ".slider-sliderSliNotiSecSmRating",
	"controlsContainer": ".slider-sliderSliNotiSecSmRating-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"center": false,
	"slideBy": 1,
	"fixedWidth": 250,
	"gutter": 16,
	"loop": false,
	"responsive": {
		"768": {
			"slideBy": 1,
			"controls": false,
			"fixedWidth": 316,
			"gutter": 32
		},
		"1280": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 316,
			"gutter": 64
		},
		"1600": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 316,
			"gutter": 64
		}
	}
});
